import http from '@/http'
const URL = '/admin/hotels'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const listHotels = async (params) => {
  const list = (await http.get(URL + '/list', { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=rooms`))
  }
  return one
}

export const saveHotel = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const delHotel = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload.id}/status`, payload)
export const exportRooms = async (params) => {
  const data = (await http.get(URL + '/exports/rooms', { params: params, responseType: 'blob' })).data
  return data
}
export const exportParticipants = async (params) => {
  const data = (await http.get(URL + '/exports/participants', { params: params, responseType: 'blob' })).data
  return data
}
export const roomsMetrics = async (params) => {
  const data = (await http.get(URL + '/rooms/metrics', { params: params })).data
  return data
}
export default {
  list,
  listHotels,
  show,
  saveHotel,
  delHotel,
  changeStatus,
  exportRooms,
  exportParticipants,
  roomsMetrics
}
